import { render, staticRenderFns } from "./createoldstuff.vue?vue&type=template&id=d0473302"
import script from "./createoldstuff.vue?vue&type=script&lang=js"
export * from "./createoldstuff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports